import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useDateRange } from "@/lib/dateRange";

export function useApiQuery(key, url, params, options = {}) {
  return useQuery({
    queryKey: [key, params],
    queryFn: () => api.get(url, params),
    ...options,
  });
}

export function useRangeQuery(key, url, extraParams = {}, options = {}) {
  const { range } = useDateRange();
  const params = { from: range.from, to: range.to, ...extraParams };
  return useQuery({
    queryKey: [key, params],
    queryFn: () => api.get(url, params),
    ...options,
  });
}
